import { Component, Input } from '@angular/core';

/**
 * Mapa de ubicación de la propiedad.
 * Migrado de `@agm/core` (no instalado → no renderizaba) a
 * `@angular/google-maps` (<google-map>). El script de la API JS de Google
 * se carga en `index.html`.
 */
@Component({
    selector: 'app-property-location',
    templateUrl: './property-location.component.html',
    styleUrls: ['./property-location.component.scss'],
})
export class PropertyLocationComponent {
    @Input() location!: { lat: number; lng: number; radius: number };

    center: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
    radius = 100;
    zoom = 15;

    readonly mapOptions: google.maps.MapOptions = {
        clickableIcons: false,
        streetViewControl: false,
        mapTypeControl: false,
    };

    readonly circleOptions: google.maps.CircleOptions = {
        fillColor: '#87CBB9',
        fillOpacity: 0.3,
        strokeColor: '#2F8F9D',
        strokeWeight: 2,
    };

    readonly markerOptions: google.maps.MarkerOptions = {
        icon: '/assets/layout/images/icons/icon-map-home.png',
    };

    ngOnChanges(): void {
        if (this.location) {
            this.center = { lat: this.location.lat, lng: this.location.lng };
            this.radius = this.location.radius ?? 100;
        }
    }
}
